var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00521 6.00016C9.29387 6.00016 10.3385 4.95549 10.3385 3.66683C10.3385 2.37817 9.29387 1.3335 8.00521 1.3335C6.71654 1.3335 5.67188 2.37817 5.67188 3.66683C5.67188 4.95549 6.71654 6.00016 8.00521 6.00016Z",
    stroke: "#767A85",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.33594 13.6668C1.33594 10.7212 4.02227 8.3335 7.33594 8.3335",
    stroke: "#767A85",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3359 14.3335C12.9928 14.3335 14.3359 12.9904 14.3359 11.3335C14.3359 9.67664 12.9928 8.3335 11.3359 8.3335C9.67908 8.3335 8.33594 9.67664 8.33594 11.3335C8.33594 12.9904 9.67908 14.3335 11.3359 14.3335Z",
    stroke: "#767A85",
    strokeWidth: 1.33333
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11 10.3335V11.6668H12.3333",
    stroke: "#767A85",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.e0a0679d7c695d43b55878871ec2b9a2.svg";
export { ForwardRef as ReactComponent };